import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Config } from './config';
import { HttpClient } from '@angular/common/http';
import { GetCustomerFeatureResponse } from '../models/customer';
import { AdminUserData } from '../models/users-permission';

@Injectable()
export class SharedService {
    /**
     * Use to avoid extra entity calls
     */
    public isEntityRequired = new BehaviorSubject<boolean>(false);

    /**
     * Represents adminUserData which needs to be emitted to admin detail screen.
     */
    public adminUserData = new BehaviorSubject<AdminUserData>(null);

    /**
     * Represents Close button click event in collection widget schedule component.
     */
    private closeDataSource = new BehaviorSubject<boolean>(false);
    public currentValue = this.closeDataSource.asObservable();

    /**
     * Represents vault directory change status.
     */
    private clearDataSource = new BehaviorSubject<boolean>(false);
    public currentClearValue = this.clearDataSource.asObservable();

    /** File upload display message */
    private displayMessageSource = new BehaviorSubject<string>('');
    public currentMessage = this.displayMessageSource.asObservable();

    constructor(private http: HttpClient) {}

    /**
     * Below function will set the initial value for the statusCodeFlag
     */
    public setCloseFlagValue(flag: boolean) {
        this.closeDataSource.next(flag);
    }

    /**
     * Below function will set the initial value for the clearDataSource
     */
    public changeMessage(flag: boolean) {
        this.clearDataSource.next(flag);
    }

    /* Will set the upload message
     * @param message
     */
    public setFileUploadMessage(message: string) {
        this.displayMessageSource.next(message);
    }

    /**
     * Get all features for user & customer
     */
    public getFeatures() {
        return this.http.get<GetCustomerFeatureResponse[]>(Config.urls.features1);
    }

    public getAllFeatures() {
        return this.http.get<GetCustomerFeatureResponse[]>(Config.urls.allAvailableFeatures);
    }
}
